import { render, staticRenderFns } from "./ApproveOwnerShipRequest.vue?vue&type=template&id=382881fb"
import script from "./ApproveOwnerShipRequest.vue?vue&type=script&lang=js"
export * from "./ApproveOwnerShipRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports